






























const namespace = 'calendar';
import { Vue, Prop, Component } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { ICountLocationsAndEvents } from '@/modules/calendar/interfaces/ICountLocationsAndEvents';
import { WeekDaysEvents } from '@/modules/calendar/store/types';
import { getWeekDayName } from '@/utils/weekDays';

@Component({
    name: 'CalendarHeader',
})
export default class CalendarHeaders extends Vue {
    @Prop() private countLocationsAndEvents!: ICountLocationsAndEvents;
    @Getter('isMobile', { namespace }) private isMobile!: number;
    @Getter('weekdaysContainerWidth', { namespace }) private weekdaysContainerWidth!: number;
    @Getter('locationWidth', { namespace }) private locationWidth!: number;
    @Getter('eventsByWeekDays', { namespace }) private eventsByWeekDays!: WeekDaysEvents[];

    public get getEventsByWeekDays() {
        return this.eventsByWeekDays;
    }

    private get headersContainerWidth() {
        return this.weekdaysContainerWidth;
    }

    private get getLocationColumnWidth() {
        const width = this.locationWidth;
        return `width: ${width};`;
    }

    public weekDayName(weekDayId: number): string {
        return getWeekDayName(weekDayId);
    }

    public getIsMobile() {
        return this.isMobile;
    }
}
